import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  locationsContainer: {
    margin: "0 0 10px",
    gap: "10px",
  },
  descriptionContainer: {
    margin: "12px 0 0",
  },
  title: {
    color: "black",
    margin: "10px 0",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
  },
  zoomTipContainer: {
    margin: "0",
    padding: "9px 14px",
    backgroundColor: "#FBFBFC",
    border: "1px solid #D9E7F0",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    gap: "10px",
  },
  zoomTipIcon: {
    marginTop: "6px",
  },
  zoomTip: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    color: "#17295B",
  },
  description: {
    borderRadius: "8px",
    border: "1px solid #D9E7F0",
    padding: "12px 8px 12px 8px",
    height: "127px",
    width: "100%",
    maxHeight: "127px",
    minHeight: "127px",
    minWidth: "100%",
    maxWidth: "100%",
    fontFamily: "Lato",
    color: "#000",
    fontSize: theme.typography.pxToRem(16),
    "&::placeholder": {
      color: "#A2A9BD",
    },
  },
  phoneContainer: {
    display: "flex",
    alignItems: "center",
    height: "68px",
  },
  countryCallCode: {
    border: "1px solid #D9E7F0",
    height: "45px",
    borderRadius: "8px",
    padding: "8px",
    fontFamily: "Lato",
    color: "#000",
    top: "-2px",
    fontSize: theme.typography.pxToRem(16),
    "&:before": {
      border: "none",
    },
    "&::placeholder": {
      color: "#A2A9BD",
    },
  },
  phoneField: {
    marginLeft: "10px",
    width: "160px",
    height: "43px",
    borderRadius: "8px",
    "& .MuiOutlinedInput-input": {
      display: "flex",
      alignSelf: "end",
      color: "#000",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    "&.MuiTextField-root": {
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(16),
      border: "1px solid #D9E7F0",
      height: "43px",
    },
  },
  phoneFieldEmpty: {
    "& .MuiOutlinedInput-input": {
      color: "#A2A9BD",
    },
  },
}));
